import PouzitiePredpis from '../model/PouzitiePredpis';
import { ClientStatus } from '../model/ClientStatus';
import { useClientFetch } from '../context/ClientStatusContext';
import { fetchPouzitiePredpisList } from '../client/pouzitiePredpisListClient';

interface ReturnType {
  pouzitiePredpisList: PouzitiePredpis[];
  pouzitiePredpisListStatus: ClientStatus;
}

export default (
  ids: string[],
): ReturnType => {
  const {
    data: pouzitiePredpisList,
    status: pouzitiePredpisListStatus,
  } = useClientFetch(
    fetchPouzitiePredpisList,
    ['', ids],
    [],
  );
  return {
    pouzitiePredpisList: pouzitiePredpisList || [],
    pouzitiePredpisListStatus,
  };
};
